module.exports = __webpack_public_path__ + "img/wx_b.b5d8d9a8.png";